import { render } from "./examView.vue?vue&type=template&id=024c9d65&scoped=true"
import script from "./examView.vue?vue&type=script&lang=js"
export * from "./examView.vue?vue&type=script&lang=js"

import "./examView.vue?vue&type=style&index=0&id=024c9d65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-024c9d65"]])

export default __exports__